import React from "react"
import PropTypes from "prop-types"
import { Flex, Switch, Tooltip } from "antd"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import IconWithBg from "ui/IconWithBg"
import { Text } from "ui/Typography"
import styles from "./TicketTypeCard.module.css"

export const TicketTypeCard = ({ ticket, isLast, onToggle, onEdit, onDelete }) => (
  <Flex vertical gap={8} className={styles.ticketCard}>
    <Flex justify="space-between" align="center">
      <Flex align="center" gap={8}>
        <Tooltip title={isLast ? "At least one ticket type must remain active" : undefined}>
          <Switch checked={ticket.enabled} disabled={isLast} onChange={(checked) => onToggle(ticket.id, checked)} />
        </Tooltip>
        <Text className={styles.ticketTitle}>{ticket.title}</Text>
      </Flex>
      <Flex gap={8}>
        <IconWithBg icon={<EditOutlined />} onClick={() => onEdit(ticket)} />
        <Tooltip title={isLast ? "At least one ticket type is required" : undefined}>
          <IconWithBg icon={<DeleteOutlined />} onClick={isLast ? undefined : () => onDelete(ticket.id)} disabled={isLast} />
        </Tooltip>
      </Flex>
    </Flex>
    {ticket.description && (
      <Text className={styles.ticketDescription}>{ticket.description}</Text>
    )}
    {ticket.maxCapacity != null && (
      <Text className={styles.ticketDescription}>Max: {ticket.maxCapacity}</Text>
    )}
  </Flex>
)

TicketTypeCard.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    enabled: PropTypes.bool.isRequired,
    maxCapacity: PropTypes.number,
  }).isRequired,
  isLast: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

TicketTypeCard.defaultProps = {
  isLast: false,
}
